export function resolveLeftNavMinimal({
  isMessagesRelatedScreen,
  leftNavCollapsed,
  leftNavForcedMinimal,
}: {
  isMessagesRelatedScreen: boolean
  leftNavCollapsed: boolean
  leftNavForcedMinimal: boolean
}) {
  return isMessagesRelatedScreen || leftNavForcedMinimal || leftNavCollapsed
}
